export default "/images/phone-outgoing.svg?5689cee5bfdc8ef677bcdc578f76ddb2";